import { UtcTime, VoiceSet, VoiceSetId } from 'shared/models';

export const Actions = {
    VOICESETS_LOAD_REQUEST: 'VOICESETS_LOAD_REQUEST',
    VOICESETS_LOAD_SUCCESS: 'VOICESETS_LOAD_SUCCESS',
    VOICESETS_LOAD_FAILURE: 'VOICESETS_LOAD_FAILURE',

    VOICESETS_RELOAD: 'VOICESETS_RELOAD',
    VOICESETS_DELETE: 'VOICESETS_DELETE',
};

const ONE_DAY = 24 * 60 * 60 * 1000;


export const voiceSetsLoadRequest = (meta?: { nextFetch: UtcTime }) => ({
    type: Actions.VOICESETS_LOAD_REQUEST,
    meta: meta || {
        nextFetch: Date.now() + ONE_DAY,
    },
});

export const voiceSetsLoadSuccess = (payload: VoiceSet[]) => ({
    type: Actions.VOICESETS_LOAD_SUCCESS,
    payload,
});

export const voiceSetsLoadFailure = (errorMessage: string) => ({
    type: Actions.VOICESETS_LOAD_FAILURE,
    payload: errorMessage,
    error: true,
});


export const voiceSetsDelete = (payload: VoiceSetId) => ({
    type: Actions.VOICESETS_DELETE,
    payload,
});

export const voiceSetsReload = () => ({
    type: Actions.VOICESETS_RELOAD,
});